import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Badge } from '@material-ui/core';
import { connect } from 'react-redux';
import { COLOR_WHITE } from '../Material';

const useStyles = makeStyles(theme => ({
    unreadMessageBadge: {
        backgroundColor: '#D5005D',
        color: COLOR_WHITE,
        height: '20px',
        fontSize: '9px',
        fontWeight: 700,
        letterSpacing: '0.08px',
        textAlign: 'center',
    },
}));

export const ChatBadge = ({ children, unreadMessages, maximumUnreadMessageCount }) => {
    const classes = useStyles();

    return <Badge badgeContent={unreadMessages} classes={{ badge: classes.unreadMessageBadge }} children={children} max={maximumUnreadMessageCount} />;
};

const mapStateToProps = state => {
    return {
        unreadMessages: state.chat.unreadMessages,
        maximumUnreadMessageCount: state.chat.maximumUnreadMessageCount,
    };
};

export default connect(mapStateToProps)(ChatBadge);
